import { writable } from 'svelte/store';
import { AREA_IMAGE_LIST } from './data';

import API from '../api';

export let config = writable({
  token: document.querySelector('#app').dataset.token || '',
  customerId: document.querySelector('#app').dataset['customer_id'] || '',
});

export let commonData = writable([]);
export let showDialog = writable(false);
export let step = writable(1);

export let selectedProcedures = writable([]);
export let selectedArea = writable({});
export let selectedPart = writable({});

export let procedureList = writable([]);
export let procedurePriceList = writable({});

export let isLoadingProcedure = writable(false);

export const initData = customerId => {
  API.getAreas(customerId)
    .then(({ data }) => commonData.set(formatAreasData(data)))
    .catch(e => console.log('e', e));
};

const formatAreasData = data =>
  data.map(areaItem => ({
    ...areaItem,
    id: areaItem.body_area,
    icon: AREA_IMAGE_LIST[areaItem.body_area].image,
    style: AREA_IMAGE_LIST[areaItem.body_area].style,
    back: areaItem.body_area.indexOf('back') !== -1,
    body_parts: areaItem.body_parts.map(itemPart => ({
      ...itemPart,
      procedures: itemPart.procedures.map(procedureItem => ({
        ...procedureItem,
        body_area: areaItem.body_area,
        body_part: itemPart.body_part,
        body_area_name: areaItem.body_area_name,
        body_part_name: itemPart.body_part_name,
      })),
    })),
  }));
